/* Al Fagr - upsell suggestions inside the cart drawer */
(function () {
  'use strict';
  if (window.__fgCartRecs) return; window.__fgCartRecs = 1;
  var D = document, last = null, busy = false;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var T = function (en, ar) { return (D.documentElement.lang || '').slice(0, 2) === 'ar' ? ar : en; };

  function cart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function paint() {
    var dr = $('cart-drawer');
    if (!dr || busy || !window.FagrRecs) return;
    var inner = $('.drawer__inner', dr), foot = inner && $('.drawer__footer', inner);
    if (!inner || !foot || dr.classList.contains('is-empty')) return;
    if ($('[data-fg-cart-recs]', inner)) return;
    busy = true;
    cart().then(function (c) {
      if (!c.items || !c.items.length) { busy = false; return; }
      var pid = last || c.items[0].product_id;
      var inCart = {}; c.items.forEach(function (i) { inCart[i.url.split('?')[0]] = 1; });
      var box = D.createElement('div');
      box.setAttribute('data-fg-cart-recs', ''); box.className = 'fg-rc-wrap'; box.hidden = true;
      foot.parentNode.insertBefore(box, foot);
      return FagrRecs.load(box, pid, { limit: 8, title: T('You may also like', 'ممكن يعجبك') }).then(function (ok) {
        if (ok) {
          Array.prototype.slice.call(box.querySelectorAll('[data-rc-item]')).forEach(function (it) {
            var a = it.querySelector('a.fg-rc__t'); var u = a && a.getAttribute('href').split('?')[0];
            if (u && inCart[u]) it.remove();
          });
          Array.prototype.slice.call(box.querySelectorAll('[data-rc-item]')).slice(2).forEach(function (it) { it.remove(); });
          if (!box.querySelector('[data-rc-item]')) box.hidden = true;
        }
        busy = false;
      });
    }).catch(function () { busy = false; });
  }

  D.addEventListener('fagr:cart-add', function (e) {
    var it = e.detail && e.detail.response && e.detail.response.items;
    last = (it && it[0] && it[0].product_id) || (e.detail.items && e.detail.items[0] && null) || last;
    var old = $('[data-fg-cart-recs]'); if (old) old.remove();
    setTimeout(paint, 350);
  });
  var dr0 = null;
  function watch() {
    var dr = $('cart-drawer');
    if (!dr || dr === dr0) return;
    dr0 = dr;
    new MutationObserver(function () { clearTimeout(watch.t); watch.t = setTimeout(paint, 250); }).observe(dr, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  if (D.readyState !== 'loading') watch(); else D.addEventListener('DOMContentLoaded', watch);
  window.addEventListener('load', function () { watch(); });
})();
